import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { store } from "@app/store";
import { IntlProvider } from "react-intl";
import ErrorBoundary from "@components/ErrorBoundary";
import AppRoute from "./AppRoute";
import messages_en from "@translation/en.json";
import messages_sv from "@translation/sv.json";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "@sass/app.scss";

const messages = {
  en: messages_en,
  sv: messages_sv,
};
const applanguage = "sv";

function App() {
  return (
    <div className="App">
      <Suspense fallback={<div />}>
        <Provider store={store}>
          <IntlProvider
            defaultLocale="sv"
            locale={applanguage}
            messages={messages[applanguage]}
          >
            <ErrorBoundary>
              <AppRoute />
            </ErrorBoundary>
          </IntlProvider>
        </Provider>
      </Suspense>
    </div>
  );
}

export default App;
